import React from 'react';
import { FCC } from 'react';

export const ButtonGroup: FCC<{}> = (props) => <div className="btn-group">{props.children}</div>;

export default ButtonGroup;
